import { Navigate } from 'react-router-dom'
import { useProviderAuth } from '@/hooks/auth'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { provider } = useProviderAuth()

  if (!provider?.is_admin) {
    return <Navigate to="/visits" replace />
  }

  return <>{children}</>
}
